document.addEventListener('DOMContentLoaded', function() {
  const uppercaseFieldIds = [
    'customer_company_name',
    'customer_contact_name',
    'customer_contact_phone',
    'svlan',
    'partner_reference',
    'delivery_interface',
    'collect_gate',
    'extra_info',
    'chamber_reference',
    'client_building_reference'
  ];

  uppercaseFieldIds.forEach(fieldId => {
    const field = document.getElementById(fieldId);
    if (field && field.type !== 'email') {
      field.addEventListener('input', function(e) {
        const start = this.selectionStart;
        const end = this.selectionEnd;
        this.value = this.value.toUpperCase();
        this.setSelectionRange(start, end);
      });
    }
  });

  const uppercaseTextareas = document.querySelectorAll('textarea#additional_informations');
  uppercaseTextareas.forEach(textarea => {
    textarea.addEventListener('input', function(e) {
      const start = this.selectionStart;
      const end = this.selectionEnd;
      this.value = this.value.toUpperCase();
      this.setSelectionRange(start, end);
    });
  });
});
